<template>
    <div class="phone-picker">
        <label>Telefon</label>
        <select v-model="value.prefix">
            <option v-for="callingCode in getCallingCodes()" :value="callingCode.value" :key="callingCode.value">{{callingCode.label}}</option>
        </select>
        <input v-model="value.number" type="text" pattern="[0-9]*" inputmode="numeric" />
    </div>
</template>

<script>
    import calling_codes from '../../../assets/calling_zones.json';

    export default {
        name: "phone-picker",
        props: ['val'],
        mounted: function() {
            if(this.val) {
                this.value = this.val;
            }
        },
        data: function () {
            return {
                value: {
                    prefix: '+48',
                    number: ''
                }
            }
        },
        methods: {
            getCallingCodes: function () {
                let result = [];

                for(let i = 0; i < calling_codes.length; i++) {
                    result.push({
                        label: calling_codes[i],
                        value: calling_codes[i]
                    });
                }

                return result;
            }
        },
        watch: {
            "val.prefix": function () {
                this.value.prefix = this.val.prefix;
            },
            "val.number": function () {
                this.value.number = this.val.number;
            },
            "value.prefix": function () {
                this.$emit('input', this.value);
            },
            "value.number": function () {
                this.value.number = this.value.number.replace(/\D/g,'');
                this.$emit('input', this.value);
            }
        }
    }
</script>